<template>
    <div class="oumi-home">
        <div class="container">

            <!-- 主要内容区域 -->
            <div class="main-content">
                <!-- 左侧内容 -->
                <div class="left-content">
                    <!-- Logo和应用图标 -->
                    <div class="logo-section">
                        <div class="app-icon">
                            <img src="@/img/home/chimo-logo.webp" alt="Chimo App Icon" />
                        </div>
                        <p class="app-slogan">Your voice, their story</p>
                    </div>

                    <!-- 应用描述 -->
                    <div class="app-description">
                        <p>
                            Your profession comes with its own stories — the kind only people in your field truly
                            understand.
                        </p>
                        <p class="app-description-text">
                            This app brings those shared moments together in one place: familiar challenges, inside
                            jokes, and the rhythm of a job you all live every day.
                        </p>
                        <p class="app-description-text">Not networking.</p>
                        <p class="app-description-text">Not meeting strangers.</p>
                        <p class="app-description-text">Just a space where your professional experiences feel seen.</p>
                    </div>

                    <!-- 下载按钮 -->
                    <!-- <div class="download-section">
                        <a href="https://apps.apple.com/app/id6748783645" target="_blank"
                            class="download-btn app-store">
                            <img src="@/img/app-store-badge.svg" alt="Download on the App Store" />
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=chat.oumi.app" target="_blank"
                            class="download-btn google-play">
                            <img src="@/img/google-play-badge.svg" alt="Get it on Google Play" />
                        </a>
                        <a href="http://cdn.oumiapp.com/oumi/reviews/oumi-gw.apk" target="_blank"
                            class="download-btn android-custom">
                            <div class="android-icon-wrapper">
                                <img src="@/img/home/android-icon.png" alt="Android" class="android-icon" />
                            </div>
                            <div class="download-text">
                                <span class="download-from">Download from</span>
                                <span class="download-store">Official Site</span>
                            </div>
                        </a>
                    </div> -->
                </div>

                <!-- 右侧手机展示 -->
                <div class="right-content">
                    <div class="phone-mockup">
                        <img src="@/img/home/chimo-home-phone.webp" alt="Chimo App Interface" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <footer class="footer">
            <div class="footer-container">
                <div class="footer-left">
                    <p class="copyright">Copyright©2025 Chimo</p>
                    <div class="footer-links">
                        <a href="https://www.chimoapp.com/agreements/PrivacyPolicy.html" target="_blank"
                            class="footer-link">Privacy Policy</a>
                        <span class="link-separator">|</span>
                        <a href="https://www.chimoapp.com/agreements/UserAgreement.html" target="_blank"
                            class="footer-link">Terms of Service</a>
                    </div>
                </div>
                <div class="footer-right">
                    <div class="contact-info">
                        <span class="contact-label">Contact us:</span>
                        <a href="tel:18017101880" class="contact-phone">
                            <img src="@/img/home/icon-phone.svg" alt="phone" />
                            85257872209
                        </a>
                        <span class="separator">|</span>
                        <a href="mailto:developer@chimoapp.com" class="contact-email">
                            <img src="@/img/home/icon-email.svg" alt="email" />
                            developer@chimoapp.com
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    </div>

</template>

<script setup>

</script>

<style lang='scss' scoped>
.oumi-home {
    width: 100%;
    min-height: 100vh;
    background-color: rgba(0, 0, 0, 1);
        background-image: url('../../assets/img/home/logo-bg.webp');
        background-repeat: repeat;
        background-size: 280px;
        background-attachment: scroll;
        position: relative;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
    }
    
    .container {
        width: 100%;
        max-width: 1900px;
        margin: 0 auto;
        padding: 0 20px;
        position: relative;
        z-index: 2;
        flex: 1;
    }
    
    // 装饰性元素
    .decorative-elements {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        pointer-events: none;
    
        .heart {
            position: absolute;
            opacity: 0.8;
            animation: float 3s ease-in-out infinite;
    
            img {
                width: 40px;
                height: auto;
            }
    
            &.heart-1 {
                top: 15%;
                right: 25%;
                animation-delay: 0s;
            }
    
            &.heart-2 {
                bottom: 25%;
                left: 15%;
                animation-delay: 1.5s;
                transform: scale(0.7);
            }
        }
    
        .flame {
            position: absolute;
            font-size: 24px;
            opacity: 0.7;
            animation: flicker 2s ease-in-out infinite;
    
            &.flame-1 {
                top: 20%;
                left: 20%;
                animation-delay: 0.5s;
            }
    
            &.flame-2 {
                bottom: 30%;
                right: 15%;
                animation-delay: 1s;
            }
        }
    
        .emoji {
            position: absolute;
            font-size: 28px;
            opacity: 0.6;
            animation: bounce 2.5s ease-in-out infinite;
    
            &.emoji-1 {
                top: 10%;
                right: 45%;
                animation-delay: 2s;
            }
        }
    }
    
    // 主要内容区域
    .main-content {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: auto;
        padding: 80px 0;
        gap: 10px;
        padding-top: 150px;
    }
    
    // 左侧内容
    .left-content {
        flex: 1;
        max-width: 800px;
        color: white;
    
        .logo-section {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-bottom: 40px;
            gap: 20px;
    
            .app-slogan {
                display: none;
            }
    
            .app-icon {
                width: 280px;
                height: 90px;
                border-radius: 20px;
                overflow: hidden;
                box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 12px;
                }
            }
    
            .app-name {
                font-size: 48px;
                font-weight: bold;
                margin: 0;
                color: white;
                text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
                font-family: 'Poppins', sans-serif;
            }
        }
    
        .app-description {
            font-size: 60px;
            line-height: 1.6;
            color: rgba(255, 255, 255, 0.9);
            text-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
            font-family: 'Poppins', sans-serif;
            margin-bottom: 30px;
    
            font-weight: 600;
            font-size: 50px;
    
    
            p {
                margin-bottom: 20px;
    
                &:last-child {
                    margin-bottom: 0;
                }
            }
    
    
    
            .app-description-text {
                font-size: 16px !important;
                color: rgba(255, 255, 255, 0.7) !important;
                margin-bottom: 6px
            }
    
            .app-description-text:nth-child(2) {
                margin-bottom: 60px !important;
            }
        }
    
        .download-section {
            display: flex;
            gap: 15px;
            align-items: center;
            flex-wrap: wrap;
    
            .download-btn {
                display: inline-block;
                transition: all 0.3s ease;
    
                &:hover {
                    transform: translateY(-3px);
                    filter: brightness(1.1);
                }
    
                img {
                    height: 60px;
                    width: auto;
                    filter: drop-shadow(0 4px 15px rgba(0, 0, 0, 0.3));
                }
    
                &.android-custom {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    background: rgba(255, 255, 255, 0.1);
                    backdrop-filter: blur(10px);
                    padding: 6px 20px 6px 8px;
                    border-radius: 10px;
                    border: 2px solid rgba(255, 255, 255, 0.3);
                    text-decoration: none;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
                    min-height: 60px;
                    box-sizing: border-box;
    
                    .android-icon-wrapper {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 44px;
                        height: 44px;
                        border-radius: 8px;
                        overflow: hidden;
    
                        .android-icon {
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }
                    }
    
                    .download-text {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        line-height: 1.2;
    
                        .download-from {
                            font-size: 11px;
                            color: rgba(255, 255, 255, 0.9);
                            font-weight: 400;
                            font-family: 'Poppins', sans-serif;
                        }
    
                        .download-store {
                            font-size: 18px;
                            color: white;
                            font-weight: 600;
                            font-family: 'Poppins', sans-serif;
                        }
                    }
    
                    &:hover {
                        transform: translateY(-3px);
                        background: rgba(255, 255, 255, 0.15);
                        border-color: rgba(255, 255, 255, 0.5);
                        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
                    }
                }
            }
        }
    }
    
    // 右侧内容
    .right-content {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 600px;
    
        .phone-mockup {
            position: relative;
            max-width: 800px;
            width: 100%;
    
            img {
                width: 100%;
                height: auto;
                filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.3));
            }
        }
    }
    
    // 动画
    @keyframes float {
    
        0%,
        100% {
            transform: translateY(0px);
        }
    
        50% {
            transform: translateY(-10px);
        }
    }
    
    @keyframes flicker {
    
        0%,
        100% {
            opacity: 0.7;
            transform: scale(1);
        }
    
        50% {
            opacity: 1;
            transform: scale(1.1);
        }
    }
    
    @keyframes bounce {
    
        0%,
        100% {
            transform: translateY(0px) rotate(0deg);
        }
    
        25% {
            transform: translateY(-5px) rotate(-5deg);
        }
    
        75% {
            transform: translateY(-2px) rotate(5deg);
        }
    }
    
    // 响应式设计
    @media (max-width: 1200px) {
        .main-content {
            gap: 40px;
            padding: 60px 0;
        }
    
        .left-content {
            .logo-section {
    
    
                .app-name {
                    font-size: 42px;
                }
            }
    
            .app-description {
                font-size: 16px;
            }
    
            .download-section {
                .download-btn img {
                    height: 50px;
                }
    
                .download-btn.android-custom {
                    min-height: 50px;
                    padding: 5px 16px 5px 6px;
                    gap: 10px;
    
                    .android-icon-wrapper {
                        width: 38px;
                        height: 38px;
                    }
    
                    .download-text {
                        .download-from {
                            font-size: 10px;
                        }
    
                        .download-store {
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    
        .right-content .phone-mockup {
            max-width: 300px;
        }
    }
    
    @media (max-width: 768px) {
        .main-content {
            flex-direction: column;
            text-align: center;
            gap: 20px;
            padding: 40px 0 60px 0;
            min-height: calc(100vh - 100px);
        }
    
        .left-content {
            order: 0;
            max-width: 100%;
    
            .logo-section {
                justify-content: center;
                margin-bottom: 30px;
                align-items: center;
    
    
    
                .app-name {
                    font-size: 36px;
                }
            }
    
            .app-description {
                font-size: 16px;
                text-align: center;
            }
    
            .download-section {
                justify-content: center;
    
                .download-btn img {
                    height: 48px;
                }
    
                .download-btn.android-custom {
                    min-height: 48px;
                    padding: 4px 14px 4px 5px;
                    gap: 10px;
    
                    .android-icon-wrapper {
                        width: 36px;
                        height: 36px;
                    }
    
                    .download-text {
                        .download-from {
                            font-size: 9px;
                        }
    
                        .download-store {
                            font-size: 15px;
                        }
                    }
                }
            }
        }
    
        .right-content {
            order: 1;
            max-width: 340px;
            margin: 0 auto;
    
            .phone-mockup {
                max-width: 340px;
            }
        }
    
        // 移动端装饰元素调整
        .decorative-elements {
            .heart {
                img {
                    width: 30px;
                }
    
                &.heart-1 {
                    top: 5%;
                    right: 10%;
                }
    
                &.heart-2 {
                    bottom: 15%;
                    left: 5%;
                }
            }
    
            .flame {
                font-size: 20px;
    
                &.flame-1 {
                    top: 10%;
                    left: 10%;
                }
    
                &.flame-2 {
                    bottom: 20%;
                    right: 5%;
                }
            }
    
            .emoji {
                font-size: 24px;
    
                &.emoji-1 {
                    top: 5%;
                    right: 35%;
                }
            }
        }
    }
    
    @media (max-width: 480px) {
    
        .app-description {
            color: rgba(255, 255, 255, 0.8) !important;
    
            p {
                margin-bottom: 10px !important;
            }
        }
    
        .container {
            padding: 0 32px;
        }
    
        .main-content {
            padding: 30px 0 50px 0;
            gap: 20px;
            min-height: calc(100vh - 80px);
        }
    
        .left-content {
            .logo-section {
                gap: 0px;
    
    
    
                .app-name {
                    font-size: 28px;
                }
            }
    
            .app-description {
                font-size: 14px;
                line-height: 1.5;
            }
    
            .download-section {
                justify-content: center;
    
                .download-btn img {
                    height: 44px;
                }
    
                .download-btn.android-custom {
                    min-height: 44px;
                    padding: 4px 12px 4px 4px;
                    gap: 8px;
    
                    .android-icon-wrapper {
                        width: 32px;
                        height: 32px;
                    }
    
                    .download-text {
                        .download-from {
                            font-size: 8px;
                        }
    
                        .download-store {
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    
        .right-content .phone-mockup {
            max-width: 390px !important;
        }
    
        // 小屏幕装饰元素进一步调整
        .decorative-elements {
            .heart img {
                width: 24px;
            }
    
            .flame {
                font-size: 18px;
            }
    
            .emoji {
                font-size: 20px;
            }
        }
    
        .app-slogan {
        display: block !important;
        color: rgba(255, 255, 255, 0.8) !important;
    }
}

// Footer样式
.footer {
    width: 100%;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(10px);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 20px 0;
    z-index: 10;
    margin-top: auto;

    .footer-container {
        max-width: 1900px;
        margin: 0 auto;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: rgba(255, 255, 255, 0.8);
        font-family: 'Poppins', sans-serif;

        .footer-left {
            .copyright {
                margin: 0 0 8px 0;
                font-size: 14px;
                color: rgba(255, 255, 255, 0.7);
            }

            .footer-links {
                display: flex;
                align-items: center;
                gap: 8px;

                .footer-link {
                    color: rgba(255, 255, 255, 0.6);
                    text-decoration: none;
                    font-size: 12px;
                    transition: all 0.3s ease;

                    &:hover {
                        color: #FFD700;
                        text-decoration: underline;
                    }
                }

                .link-separator {
                    color: rgba(255, 255, 255, 0.4);
                    font-size: 12px;
                }
            }
        }

        .footer-right {
            .contact-info {
                display: flex;
                align-items: center;
                gap: 15px;
                font-size: 14px;

                .contact-label {
                    color: rgba(255, 255, 255, 0.7);
                }

                .contact-phone,
                .contact-email {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    color: rgba(255, 255, 255, 0.9);
                    text-decoration: none;
                    transition: all 0.3s ease;

                    &:hover {
                        color: #FFD700;
                        transform: translateY(-1px);
                    }

                    i {
                        font-size: 12px;
                        opacity: 0.8;
                    }
                }

                .separator {
                    color: rgba(255, 255, 255, 0.4);
                    font-size: 12px;
                }
            }
        }
    }
}

// Footer响应式设计
@media (max-width: 768px) {
    .footer {
        .footer-container {
            flex-direction: column;
            gap: 15px;
            text-align: center;

            .footer-left {
                order: 2;

                .copyright {
                    margin: 0 0 6px 0;
                    font-size: 12px;
                }

                .footer-links {
                    justify-content: center;

                    .footer-link {
                        font-size: 11px;
                    }

                    .link-separator {
                        font-size: 10px;
                    }
                }
            }

            .footer-right {
                order: 1;

                .contact-info {
                    flex-direction: column;
                    gap: 10px;

                    .separator {
                        display: none;
                    }
                }
            }
        }
    }
}

@media (max-width: 480px) {
    .footer {
        padding: 15px 0;

        .footer-container {
            padding: 0 15px;

            .footer-left {
                .copyright {
                    font-size: 10px;
                    margin: 0 0 4px 0;
                }

                .footer-links {
                    .footer-link {
                        font-size: 10px;
                    }

                    .link-separator {
                        font-size: 9px;
                    }
                }
            }

            .footer-right .contact-info {
                font-size: 12px;
                align-items: flex-start;
                .contact-phone,
                .contact-email {
                    i {
                        font-size: 10px;
                    }
                }
            }
        }
    }
}
</style>